var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-dialog",
    {
      ref: "priceViewDialog",
      attrs: {
        "custom-class": "price-view-dialog",
        visible: _vm.visible,
        title: _vm.$t("CargoMsg.Cargo_OpenPriceInfo"),
        width: "1408px",
        top: "5vh",
        "can-maximize": _vm.source === "priceBatch",
        source: _vm.source
      },
      on: { close: _vm.cancelHandler }
    },
    [
      _vm.visible
        ? _c("open-price-view", {
            ref: "priceViewPop",
            attrs: { source: "priceViewDialog", "only-view": true }
          })
        : _vm._e(),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { no: "Cancel" }, on: { click: _vm.cancelHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }